import '../common/template/dependencies'
import React, { Component } from 'react'
import axiosInstance from '../main/axios';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import App from './app'
import Auth from '../auth/auth'
import { validateToken, logout } from '../auth/authActions'

let authResponseInterceptorId = null;

function isAuthFailureResponse(response) {
    if (!response || response.status !== 403) {
        return false;
    }
    const { data } = response;
    return Boolean(data && Array.isArray(data.errors) && data.errors.length);
}

class AuthOrApp extends Component {
    componentWillMount() {
        if (this.props.auth.user) {
            this.props.validateToken(this.props.auth.user.token)
        }
    }

    componentDidMount() {
        if (authResponseInterceptorId !== null) {
            return;
        }

        authResponseInterceptorId = axiosInstance.interceptors.response.use(
            response => response,
            error => {
                if (isAuthFailureResponse(error.response)) {
                    this.props.logout();
                }

                return Promise.reject(error);
            }
        );
    }

    render() {
        const { user, validToken } = this.props.auth
        if (user && validToken) {
            axiosInstance.defaults.headers.common['authorization'] = user.token
            return <App>{this.props.children}</App>
        } else if (!user && !validToken) {
            return <Auth />
        } else {
            return false
        }
    }
}

const mapStateToProps = state => ({ auth: state.auth })
const mapDispatchToProps = dispatch => bindActionCreators({ validateToken, logout }, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(AuthOrApp)